<template>
  <div>
    <el-dialog
            title="New Calculated Field"
            :visible.sync="new_calculated_field_modal">
        Field Name:
        <el-input v-model="edited_calculated_field"></el-input>
        <div style="margin-top:20px;">Formula:</div>
        <formula-editor @change_formula="change_formula" @original_value=""></formula-editor>
        <el-button @click="save_calculated" style="margin-top:20px;">Save</el-button>
    </el-dialog>
    <el-dialog
        title="Column Lineage"
        :visible.sync="show_lineage"
        :fullscreen="true"
    >

      <div>
        <NetworkTimeline
            :chartData="lineage"
            width="1600"
            height="1600"
        >
        </NetworkTimeline>
      </div>


    </el-dialog>

    <el-dialog
        :visible.sync="showDetails"
        title="Details about a column"
    >
      <div>
        <h2>{{selectedColumn.display_name}}</h2>
        <h3>Description</h3>
        {{selectedColumn.description}}
        <div v-if="selectedColumn.calculated_expression">
          <h3>Formula</h3>
          {{selectedColumn.calculated_expression}}
        </div>
        <div v-if="selectedColumn.pattern_info">
          <h3>Pattern</h3>
          <div><strong>Scope (1st step):</strong></div>
          <div>Name: {{selectedColumn.pattern_info.scope_name}}</div>
          <div>Definition: {{selectedColumn.pattern_info.scope_spec}}</div>
          <div><strong>Pattern (2nd step): </strong></div>
          <div>Name: {{selectedColumn.pattern_info.pattern_name}}</div>
          <div>Definition: {{selectedColumn.pattern_info.pattern_spec}}</div>
        </div>

        <div v-if="selectedColumn.db_column_type">
          <h3>Column Type</h3>
          {{selectedColumn.db_column_type}}, using approximately {{selectedColumn.byte_estimate}} bytes
        </div>
      </div>

      <div v-if="selectedColumn.popular_values && selectedColumn.popular_values.length > 0">
        <h3>Popular Values</h3>

        <el-table v-if="showDetails"
                  :data="selectedColumn.popular_values"
                  style="width: 100%">
          <el-table-column
              v-for = "column in table_popular"
              v-bind:label = column.name
              v-bind:prop = column.prop
          >
            <template slot-scope="scope">
              <span v-if="column.prop.toLowerCase() === 'colors'">
                  <span v-for="color in scope.row.colors">
                    <div
                          :style="
                            'padding: 5px; margin: 0px; background-color:' +
                             color.color +
                             '; color:' +
                             tinycolor.mostReadable(color.color,['#000', '#fff', '#F5DF8F','#2178B4']).toHexString()
                          "
                    >{{color.color}}</div>
                    <div style="font-size:smaller;margin-bottom:5px;padding-bottom:0px;" v-if="color.assignment_type_name && color.chart_color_scheme">
                        {{color.assignment_type_name}} / {{color.chart_color_scheme}}
                    </div>
                  </span>
              </span>
              <span v-else>
                {{scope.row[column.prop]}}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <p>* Colors only appear if this field was used to color a chart prior to the last time this table was optimized.</p>
      </div>
      <div v-else style="margin-top:30px;">
        <em>Popular values only appear for values that have over one occurrence and are not null.
          Also, only the first 50 appear here, and only if the field has a total of fewer than 10,000 different values.</em>
      </div>

    </el-dialog>

    <div v-if="have_data">
      <p>Last updated {{other_metadata.last_updated}}</p>
    </div>

    <div v-if="have_data && other_metadata.bytesShouldBeFiltered>0" style="background-color:pink; margin: 10px;">
      Need to remove or change data type of columns to have smaller optimized data (need to remove {{other_metadata.bytesShouldBeFiltered}} bytes.
    </div>

    <div v-if="have_data" style="margin-bottom:10px;">
      Show
      <el-select v-model="filterValue">
        <el-option
            v-for="item in other_metadata.status_values"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
        <el-button @click="initiate_new_calcuated">Add Calculated Column</el-button>
    </div>

    <el-table v-if="have_data"
        :data="filtered_headers"
        style="width: 100%">
      <el-table-column
          v-for = "column in table_display_info"
          v-bind:label = column.name
          v-bind:prop = column.prop
      >
        <template slot-scope="scope">
            <span v-if="column.prop.toLowerCase() === 'display_name'">
                <span :id="scope.row[column.prop]" @click="get_details(scope.row)"><strong>{{scope.row[column.prop]}}</strong></span>
            </span>
            <span v-else-if="column.prop.toLowerCase() === 'user_friendly_def'">
                <span v-if="scope.row['user_friendly_def']">{{scope.row['user_friendly_def']}}</span>
                <span v-else>{{scope.row['auto_description']}}</span>
            </span>
            <span v-else-if="column.prop.toLowerCase() === 'ghost_dependencies'">
                <div v-if="scope.row.maps_used">
                  <strong>Maps Used</strong>
                  <ul>
                    <li v-for="map_used in scope.row.maps_used"><a :href="map_used.url">{{map_used.name}}</a></li>
                  </ul>
                </div>
              <div v-if="scope.row.columns_used.length > 0">
                  <el-button @click="col_details(scope.row.id)">Columns Used</el-button>
                <ul>
                  <li v-for="col_used in scope.row.columns_used"><a :href="'#' + col_used">{{col_used}}</a></li>
                </ul>
              </div>
              <div v-if="scope.row.referred_columns">
                  <strong>Referred Columns</strong>
                <ul>
                  <li v-for="referred_col in scope.row.referred_columns"><a :href="'#' + referred_col.name">{{referred_col.name}}</a></li>
                </ul>
              </div>

            </span>
            <span v-else-if="column.prop.toLowerCase() === 'ghost_technical_definition'">
                <span v-if="scope.row.calculated_expression">
                  <div><strong>Formula</strong></div>
                  {{scope.row.calculated_expression}}
                </span>
                <span v-else-if="scope.row.pattern_info">
                  <div><strong>Scope (1st step):</strong></div>
                  <div>Name: {{scope.row.pattern_info.scope_name}}</div>
                  <div>Definition: {{scope.row.pattern_info.scope_spec}}</div>
                  <div><strong>Pattern (2nd step): </strong></div>
                  <div>Name: {{scope.row.pattern_info.pattern_name}}</div>
                  <div>Definition: {{scope.row.pattern_info.pattern_spec}}</div>
                </span>
                <span v-else-if="scope.row.data_source">
                  <strong>{{scope.row.data_source.name}}</strong>
                </span>

            </span>
            <span v-else-if="column.prop.toLowerCase() === 'status'">
                {{scope.row['status']}}
              <!---
              <div style="font-size:smaller" @click="toggle(scope.row)">
                {{scope.row['status']==='Optimized' ? 'exclude' : 'include' }}
              </div>
              --->
            </span>
            <span v-else>
              {{scope.row[column.prop]}}
            </span>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
const tinycolor = require('tinycolor2')
export default {
  name: "MetadataViewer",
  props: ['flat_id'],
  data() {
    return {
        edited_calculated_field_formula: '',
      edited_calculated_field: '',
      new_calculated_field_modal: false,
      tinycolor: tinycolor,
      have_data: false,
      headers: [],
      table_display_info: [],
      lineage: null,
      show_lineage: false,
      other_metadata: null,
      filterValue: 'Optimized',
      selectedColumn: {
        display_name: ''
      },
      showDetails: false,
      table_popular: [
        {prop: 'value', name: 'Value'},
        {prop: 'count', name: 'Frequency'},
        {prop: 'colors', name: 'Color(s)*'},
      ]
    }
  },
  computed: {
    filtered_headers: function () {
      if (!this.filterValue || this.filterValue==='All') {
        return this.headers
      } else {
        return this.headers.filter(column => column.status===this.filterValue)
      }
    },
  },
  mounted() {
    this.get_headers()
  },
  methods: {
      save_calculated() {
          // flattened/{flattened_table_id}/columns/calculated
          axios.post('/api/flattened/' + + this.flat_id + '/columns/calculated', {
              formula: this.edited_calculated_field_formula,
              field_name: this.edited_calculated_field
          })
              .then(response => {
                  this.new_calculated_field_modal = false
                  console.log('saved successfully')
              })
              .catch(error => {
                  console.log('did not successfully save')
              })
      },
    change_formula(formula) {
        // flattened/{flattened_table_id}/columns/calculated
        this.edited_calculated_field_formula = formula
    },
    initiate_new_calcuated() {
        this.new_calculated_field_modal = true
    }  ,
    get_details(row) {
      this.selectedColumn = row
      this.showDetails = true
    },
    get_headers() {
      axios.get('/api/flattened/metadata_extended/' + this.flat_id)
          .then(response => {
            this.headers = response.data.columns
            this.table_display_info = response.data.table_display_info
            this.other_metadata = response.data.other_metadata
            this.other_metadata.status_values.push('All')
            this.have_data = true
          })
          .catch(error => {
            console.log('could not load extended metadata')
          })
    },
    col_details(id) {
      this.lineage = null
      let found = false
      this.headers.forEach((header) => {
        if(header.id===id) {
          this.lineage = header.lineage
          console.log(this.lineage)
          this.show_lineage= true
          console.log('set to show lineage')
          found = true
        }
      })
      this.show_lineage = found
    },
  }
}
</script>

<style scoped>

</style>